var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "sellsyAcademy",
      staticClass: "slider-item slider-item--sellsy-academy"
    },
    [
      _c("div", { staticClass: "slider-item__avatar" }, [
        _c("img", {
          ref: "avatar",
          attrs: {
            src:
              "/ressources/logged/img/illustrations/recap2024/avatar-recap.svg",
            width: "108"
          }
        })
      ]),
      _vm._v(" "),
      _vm._l(_vm.text, function(item) {
        return _c("p", { key: item, staticClass: "slider-item__text" }, [
          _vm._v("\n        " + _vm._s(item) + "\n    ")
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "actionButton", staticClass: "slider-item__button" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("recap.slider.SellsyAcademySlide.button")
            },
            on: { click: _vm.handleClick }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }